export const threads = ($http: HttpApi) => ({
  list: (params: HttpParams['params'] = {}) => $http.$get('/ai/chat/threads', { params }),
  create: (data: HttpParams['body'] = {}) => $http.$post('/ai/chat/threads', { body: data }),
  update: (id: string, data: HttpParams['body'] = {}) => $http.$patch(`/ai/chat/threads/${id}`, { body: data }),
  delete: (id: string) => $http.$delete(`/ai/chat/threads/${id}`),
});
